module.exports = __webpack_public_path__ + "img/D_299.601628e1.png";